import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { NextActionCaptureOrder } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/NextActions/components/CaptureOrder/NextActionCaptureOrder';
import { NextActionCompleteOnboarding } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/NextActions/components/CompleteOnboarding/NextActionCompleteOnboarding';
import { NextActionPayFirstInstalment } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/NextActions/components/PayFirstInstalment/NextActionPayFirstInstalment';

interface NextActionFactoryProps {
  action: Action;
  paymentMethodDetailEntity: BnplPaymentMethodDetailEntity;
}

// TODO: Separate actions into components
export const NextActionFactory = ({ action, paymentMethodDetailEntity }: NextActionFactoryProps) => {
  if (action === Action.COMPLETE_ONBOARDING) {
    return <NextActionCompleteOnboarding paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  if (action === Action.PAY_FIRST_INSTALMENT) {
    return <NextActionPayFirstInstalment paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  if (action === Action.CAPTURE_ORDER) {
    return <NextActionCaptureOrder paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  return null;
};
